import { render, staticRenderFns } from "./QuickCommend.vue?vue&type=template&id=7b684a81&"
import script from "./QuickCommend.vue?vue&type=script&lang=js&"
export * from "./QuickCommend.vue?vue&type=script&lang=js&"
import style0 from "./QuickCommend.vue?vue&type=style&index=0&id=7b684a81&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports